module.exports = __webpack_public_path__ + "static/media/edreams.bec08da5.ico";